import styled from 'styled-components';

export const SectionTitle = styled.div`
  color: #fff;
  //font-weight: bold;
  margin: 30px 0 10px;
  padding-bottom: 15px;
  border-bottom: 1px solid #595d64;
`;
